import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import BrianyCareLogo from "../../assets/auth/BrainyCare-Logo.jpg";
import axios from "axios";


const LowerExtremelyVenousDopplerView = () => {
  const { filename } = useParams();
  const [examData, setExamData] = useState(null);

const fetchData = async () => {
      try {
   const response = await axios.post(
        `/v2/ag/v1/${window.getPracticeId()}/imaging/get-image/id`,
        { row_id: parseInt(filename, 10) }
      );
      
      if (response?.data?.data[0]) {
        const raw = response.data?.data[0];
        const parsedData = JSON.parse(raw.data);
        setExamData(parsedData);
      }
      } catch (error) {
        console.error("Error fetching exam data:", error);
      }
    };
  useEffect(() => {
    if (filename) fetchData();
  }, [filename]);

  const formatDate = (date) => {
    const parsed = dayjs(date);
    return parsed.isValid() ? parsed.format("MMM D, YYYY") : "";
  };

  const tableHeaders = [
    "Compressible",
    "Spontaneous",
    "Phasic",
    "Augment",
    "Competent",
    "pulsatile",
  ];

  const renderVeinRow = (veinName, values) => (
    <tr className="text-sm text-center border-t" key={veinName}>
      <td className="border px-2 py-1 font-semibold">{veinName}</td>
      {values.map((val, idx) => (
        <td key={idx} className="border px-2 py-1">
          {val}
        </td>
      ))}
    </tr>
  );

  return (
<div
  id={examData ? "report-ready" : undefined}
  className="p-6 bg-white min-h-screen w-full flex justify-center items-center"
>
  <div className="w-full max-w-4xl border border-gray-300 rounded-md p-6 shadow-sm">
        {/* Header */}
        <div className="flex items-start justify-center mb-6">
          <img src={BrianyCareLogo} alt="Logo" className="w-14 h-14 mr-4" />
          <div>
            <h1 className="text-xl text-start font-bold text-blue-600 leading-none">C-HIM</h1>
            <p className="text-sm font-semibold mt-1">
              Center for Hypertension & Internal Medicine
            </p>
          </div>
        </div>

        {/* Title */}
        <h2 className="text-center font-bold text-base mb-6 uppercase">
          LOWER EXTREMELY VENOUS DOPPLER
        </h2>

        {/* Patient Info */}
        {examData && (
          <>
             <div className="flex justify-start text-sm text-left w-full mb-4">
                                                              <div className="grid grid-cols-[auto_20px_1fr] gap-x-2 gap-y-1">
                                                                <span><strong>MR No#</strong></span>
                                                                <span>:</span>
                                                                <span>{examData.patientid}</span>
                                                            
                                                                <span><strong>Name</strong></span>
                                                                <span>:</span>
                                                                <span>{examData.pat_name}</span>
                                                            
                                                                <span><strong>Age</strong></span>
                                                                <span>:</span>
                                                                <span>{examData.age}</span>
                                                            
                                                                <span><strong>Exam Date</strong></span>
                                                                <span>:</span>
                                                                <span>{dayjs(examData.examDate).format("MM, DD, YYYY")}</span>
                                                            
                                                                <span><strong>Date of Birth</strong></span>
                                                                <span>:</span>
                                                                <span>{dayjs(examData.pat_dob).format("MMM D, YYYY")}</span>
                                                            
                                                                <span><strong>Provider</strong></span>
                                                                <span>:</span>
                                                                <span>{examData.providername}</span>
                                                             <span><strong>Patients History :</strong></span>
                                                                <span>:</span>
                                                                <span>{examData.history}</span>
                                                               
                                                              </div>
                                                            </div>

         

            {/* Table */}
            <div className="overflow-x-auto mt-4">
              <table className="min-w-full border border-gray-300 text-center">
                <thead>
                  <tr className="bg-gray-50 text-sm font-bold text-gray-700">
                    <th className="border px-2 py-1">#</th>
                    <th colSpan="12" className="border px-2 py-1">
                      Compression ultrasound / Color Flow / Possed Doppler
                    </th>
                  </tr>
                  <tr className="text-xs bg-gray-50 text-gray-600 font-semibold">
                    <th className="border px-2 py-1"></th>
                    {tableHeaders.map((header) => (
                      <th key={header} colSpan="2" className="border px-2 py-1">
                        {header}
                      </th>
                    ))}
                  </tr>
                  <tr className="bg-gray-50 text-xs text-gray-600">
                    <th className="border px-2 py-1"></th>
                    {Array(6).fill(null).map((_, index) => (
                      <React.Fragment key={index}>
                        <th className="border px-2 py-1">R</th>
                        <th className="border px-2 py-1">L</th>
                      </React.Fragment>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(examData.veinTable).map((vein) =>
                    renderVeinRow(vein, examData.veinTable[vein])
                  )}
                </tbody>
                <tfoot>
                  <tr className="bg-gray-50 text-gray-600 font-semibold text-sm">
                    <td className="border px-2 py-1"></td>
                    <td colSpan={3} className="border px-2 py-1">MINIMAL</td>
                    <td colSpan={3} className="border px-2 py-1">REDUCED</td>
                    <td colSpan={3} className="border px-2 py-1">ABNORMAL</td>
                    <td colSpan={3} className="border px-2 py-1">NOT ASSESSED</td>
                  </tr>
                </tfoot>
              </table>
            </div>

            {/* Tech Impression */}
            <div className="mt-4 text-start text-sm">
              <strong>Tech Impression :</strong> {examData.techImpression}
            </div>

            {/* Technologist */}
            <div className="mt-1 text-start text-sm">
              <strong>Technologist :</strong> {examData.technologist}
            </div>

          <div className="flex justify-end w-full">
  <div className="flex border w-full max-w-xl min-w-[250px] p-2">
    
    {/* Signature - left half */}
    <div className="w-1/2 pr-4 border-r border-gray-300 break-words whitespace-pre-wrap">
      <div className="font-semibold">{examData.signature}</div>
    </div>

    {/* Right half - fixed layout */}
    <div className="w-1/2 pl-4 text-sm text-left">
      <div>Digitally Signed by</div>
     <div>{examData?.createdby||''}</div>
         <div>{dayjs(examData.dateofservice).format("MM-DD-YYYY")}</div>
    </div>
    
  </div>
</div>
          </>
        )}
      </div>
    </div>
  );
};

export default LowerExtremelyVenousDopplerView;
